import React, { useState, useEffect } from "react";
import { Button, Result } from "antd";
import { useLocation, useHistory } from "react-router-dom";

const DesktopStep6 = ({ setLoading, loading }) => {
    const history = useHistory();
    const location = useLocation();
    const [statusPayment, setStatusPayment] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => { handlePayment(); }, []);

    const handlePayment = async () => {
        setLoading(true);
        const queryParams = new URLSearchParams(location.search);
        const status = queryParams.get("status");
        setStatusPayment(status === "1");
        setLoading(false);
        setLoaded(true);
        setTimeout(() => {
            sessionStorage.removeItem("bookingInfo");
            const { pathname } = location;
            history.replace(pathname);
        }, 5000);
    };

    return (
        <div className="desktop-step6-container" style={{ background: '#f0f4f8', minHeight: '100vh', paddingBottom: '48px', fontFamily: "'Inter', sans-serif", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: '100%', maxWidth: '700px', background: 'white', borderRadius: '24px', boxShadow: '0 20px 60px rgba(0,0,0,0.08)', padding: '48px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: '40px' }}>

                {loaded ? (
                    <Result
                        status={statusPayment ? "success" : "error"}
                        title={<span style={{ fontWeight: 700, fontSize: '24px', color: '#1e293b' }}>{statusPayment ? "Thanh Toán Thành Công!" : "Thanh Toán Thất Bại!"}</span>}
                        subTitle={<span style={{ color: '#64748b', fontSize: '15px' }}>{statusPayment
                            ? "Tuyệt vời, đơn đặt chỗ của bạn đã được xác nhận. Vui lòng kiểm tra email để nhận thông tin chuyến bay."
                            : "Rất tiếc, giao dịch của bạn không thể hoàn tất. Vui lòng thử lại hoặc chọn phương thức khác."}</span>}
                        extra={[
                            <Button type="primary" key="home" size="large"
                                style={{
                                    fontWeight: 700, padding: '0 32px', height: '48px', borderRadius: '12px', border: 'none', fontSize: '15px',
                                    background: statusPayment ? 'linear-gradient(135deg, #16a34a, #15803d)' : 'linear-gradient(135deg, #ef4444, #dc2626)',
                                    boxShadow: statusPayment ? '0 4px 14px rgba(22,163,74,0.3)' : '0 4px 14px rgba(239,68,68,0.3)'
                                }}
                                onClick={() => window.location.href = "/"}>
                                Về Trang Chủ
                            </Button>,
                        ]}
                    />
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 0' }}>
                        <div style={{ width: '56px', height: '56px', border: '4px solid #bfdbfe', borderTopColor: '#2563eb', borderRadius: '50%', animation: 'dt-spin 0.8s linear infinite', marginBottom: '24px' }} />
                        <h3 style={{ fontSize: '20px', fontWeight: 700, color: '#1e293b' }}>Đang xử lý kết quả giao dịch...</h3>
                        <style>{`@keyframes dt-spin { to { transform: rotate(360deg); } }`}</style>
                    </div>
                )}

                <div style={{ marginTop: '32px', borderTop: '1px solid #e2e8f0', paddingTop: '28px', width: '100%' }}>
                    <h4 style={{ color: '#64748b', fontWeight: 500, marginBottom: '16px' }}>Khám phá thêm tính năng của iPass</h4>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                        {['Vé máy bay', 'Khách sạn', 'Thuê xe'].map(item => (
                            <Button key={item} style={{ borderRadius: '20px', padding: '0 20px', fontWeight: 600, color: '#2563eb', borderColor: '#bfdbfe', fontSize: '13px' }}>{item}</Button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DesktopStep6;
